<style lang="less">
.accBar {
  background: #ca2f13;
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 1rem;

  &__logo {
    position: absolute;
    top: 0.1rem;
    left: 0.2rem;
    .k-user-logo {
      width: 0.8rem;
      height: 0.8rem;
    }
  }
  &__info {
    position: absolute;
    top: 0.1rem;
    left: 1.1rem;
    font-size: 0.24rem;
    line-height: 1.6;
  }

  &__opts {
    position: absolute;
    top: 0.22rem;
    right: 0;
    font-size: 0.24rem;
  }

  &__goSoft,
  &__goExit {
    display: inline-block;
    height: 0.56rem;
    line-height: 0.56rem;
    padding: 0 0.4rem;
  }
  &__goSoft {
    background-image: linear-gradient(270deg, #c7a862 0%, #f8efbc 100%);
    box-shadow: inset 0 0.03rem 0.06rem 0 rgba(248, 247, 242, 0.5);
    border-radius: 0.36rem;
    color: #000;
    &:visited {
      color: #000;
    }
  }
  &__goExit,
  &__goExit:visited {
    color: #fff;
  }
}
</style>
<template>
  <div v-if="myUid > 0" class="accBar">
    <div class="accBar__logo">
      <k-user-logo size="small" :src="myInfo.logoSm" :lv="myInfo.lvKey" />
    </div>
    <div class="accBar__info">
      <div class="accBar__nick">{{ myInfo.nick }}</div>
      <div class="accBar__mob">
        {{ myInfo.mobile.replace(/^(\d{3})\d{4}/, '$1****') }}
      </div>
    </div>
    <div class="accBar__opts">
      <a class="accBar__goSoft" href="/award2020/dianjin/list">我的软件</a>
      <a class="accBar__goExit" href="javascript:;" @click="goLogout()">退出</a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'app-account-bar',
  props: [],
  computed: {
    ...mapGetters('account', ['myInfo', 'myUid'])
  },
  methods: {
    ...mapActions('account', ['goLogout'])
  }
}
</script>
